import axios from "axios";

const Api = axios.create({
    //baseURL : `${global.config.live_url}/api`,
    baseURL : `https://menastockinstore.com/api`,
});

// Add an interceptor for all requests

Api.interceptors.request.use( config => {
    const accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzYxOTc0MjgxLCJpYXQiOjE3NTkzODIyODEsImp0aSI6ImMwYWRhYTRkYmJhZTRkYzRhZjYzNjUxYzk0ZmQ0ZTJkIiwidXNlcl9pZCI6MX0.O9BUoRCTIv7cqDskGjZu9wSFICLjsFaIcGG6kDvnV7E";
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;

});
export default Api;